import { XYoutubeExtension, YoutubeExtension } from '@adornis/buildify/client/extensions/YoutubeExtenions.js';
import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import type { BaseYoutube } from '@adornis/buildify/db/extensions/BaseYoutube';
import { css } from '@adornis/chemistry/directives/css';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { consentCookieValueSubject } from '../../../../tracking/client/consent-tool';
import { CookieFactory } from '../../../../tracking/client/types/CookieFactory';

export const BuildifyCampusYoutubeExtension: BuildifyExtension = {
  ...YoutubeExtension,
  render(instance, { defaultValues, isSubelement, dropzoneAfter, dropzoneBefore }) {
    return html`
      <d-youtube-extension
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      >
      </d-youtube-extension>
    `;
  },
  toolbar: {
    icon: 'video',
    text: YoutubeExtension.toolbar!.text,
  },
};

@customElement('d-youtube-extension')
export class DubniumVimeoExtension extends XYoutubeExtension {
  override connectedCallback(): void {
    super.connectedCallback();

    consentCookieValueSubject.subscribe(value => {
      this.requestUpdate();
    });
  }

  override _content(content: BaseYoutube) {
    if (!CookieFactory.consentCookie.getValue('allowYoutube', 'boolean'))
      return html`
        <d-flex
          ${css({ width: '100%', aspectRatio: '16 / 9', color: '#fff', background: '#333' })}
          center
          crossaxis-center
          space="md"
        >
          <d-text> Bitte aktiviere YouTube-Cookies, um das Video abspielen zu können. </d-text>
          <d-button
            @click=${() => {
              CookieFactory.consentCookie.setValue('allowYoutube', 'true');
              this.requestUpdate();
            }}
          >
            Cookies erlauben
          </d-button>
        </d-flex>
      `;
    return super._content(content);
  }
}
